import { render, staticRenderFns } from "./VideoSide.vue?vue&type=template&id=6a13ae93&scoped=true&"
import script from "./VideoSide.vue?vue&type=script&lang=js&"
export * from "./VideoSide.vue?vue&type=script&lang=js&"
import style0 from "./VideoSide.vue?vue&type=style&index=0&id=6a13ae93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a13ae93",
  null
  
)

export default component.exports